import React from 'react';
import { path } from 'ramda';

import LoadField from 'components/common/fields/LoadField';
import { budget } from 'constants/dictionaries';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';

export const RequestBasic = ({ request }) => (
    <div>
        <DefinitionHeader translate="request.headers.request_information" iconType='info-outline' />
        <div className="panel-view">
            <DefinitionField translate="request.organization" text={ request.organizationName } />
            <DefinitionField translate="request.department" text={ request.departmentName } />
            <DefinitionField translate="request.legal" text={ path(['kadrsyst', 'legalName'], request) || path(['kadrsyst', 'legal'], request) } />
            <DefinitionField translate="request.legalDepartment" text={ path(['kadrsyst', 'departmentName'], request) || path(['kadrsyst', 'department'], request) } />
            <DefinitionField translate="request.legalCell" text={ path(['kadrsyst', 'cellName'], request) || path(['kadrsyst', 'cell'], request) } />
            <DefinitionField translate="request.quantity" text={ request.quantity } />
            <DefinitionField translate="request.reason" text={ request.reasonName } />
            <DefinitionField translate="request.replacing" text={ request.replacingFullName } />
            <DefinitionField translate="request.budget" text={ request.budgetName } />
            <DefinitionField translate="request.budget" show={request.budget}>
                <LoadField loadName={budget} fieldId={ request.budget } />
            </DefinitionField>
            <DefinitionField translate="request.deadline" text={ request.deadline } />
            <DefinitionField translate="common.city" text={request.town ? request.town.title : false} />
        </div>
    </div>
);
